import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, LayoutGrid, Map } from 'lucide-react';
interface MetaphorCardProps {
  title: string;
  description: string;
  icon: 'bucket' | 'closet' | 'gps';
  index: number;
}
export function MetaphorCard({
  title,
  description,
  icon,
  index
}: MetaphorCardProps) {
  const icons = {
    bucket: <Droplets className="w-8 h-8 text-[#52B788]" data-id="element-54" />,
    closet: <LayoutGrid className="w-8 h-8 text-[#F4A261]" data-id="element-55" />,
    gps: <Map className="w-8 h-8 text-[#2D6A4F]" data-id="element-56" />
  };
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.15
  }} className="bg-[#FFF8F0] p-6 rounded-2xl border-2 border-[#2D6A4F]/10 text-center hover:border-[#2D6A4F]/30 transition-colors" data-id="element-57">
      <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm" data-id="element-58">
        {icons[icon]}
      </div>
      <h3 className="text-lg font-bold text-[#1B4332] mb-2" data-id="element-59">{title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed" data-id="element-60">{description}</p>
    </motion.div>;
}